{
  "toast": {
    "analyticsRefreshed": "Analytics refreshed",
    "ruleSaved": "Rule enregistré",
    "ruleRemoved": "Rule removed",
    "postRescheduled": "Post rescheduled",
    "campaignCreated": "Campaign créé",
    "submittedForApproval": "Submitted pour approbation",
    "channelConnectedSuccessfully": "Channel connected successfully",
    "channelAddedFinishConnectionBelow": "Channel ajoutered — finish connection below",
    "connectedDemoMode": "Connected (demo mode)",
    "disconnected": "Disconnected",
    "reconnectStarted": "Reconnect started",
    "replyPublished": "Reply published",
    "commentResolved": "Comment resolved",
    "assigned": "Assigned",
    "replySent": "Réponse envoyée",
    "conversationAssigned": "Conversation assigned",
    "escalatedDeskTicketWorkflowTriggered": "Escalated — Desk ticket flux de travail triggered",
    "noteSavedForYourTeam": "Note enregistré pour votre team",
    "savedReplyAdded": "Saved reply ajoutered",
    "inboundMessageSimulated": "Inbound message simulated",
    "published": "Published",
    "connectedInDemoModeRunTestsBelow": "Connected in demo mode — run tests below",
    "allTestsPassed": "All tests passed",
    "diagnosticsComplete": "Diagnostics complete",
    "tokenRefreshAttempted": "Token refresh attempted",
    "notificationPreferencesSaved": "Notification preferences enregistré",
    "keywordAdded": "Keyword ajoutered",
    "folderCreated": "Folder créé",
    "uploadComplete": "Upload complete",
    "assetRemoved": "Asset removed",
    "publishRetryCompleted": "Publish retry terminé",
    "publishedToConnectedChannels": "Published à connected channels",
    "reviewIngestedSimulatedWebhook": "Review ingested (simulated webhook)",
    "brandCreated": "Brand créé",
    "competitorAdded": "Competitor ajoutered",
    "integrationCredentialsSaved": "Integration credentials enregistré",
    "reportExported": "{{reportType}} exporté",
    "leadCreated": "Prospect n°{{id}} créé"
  },
  "errors": {
    "analyticsUnavailable": "Analytics unavailable",
    "syncFailed": "Échec de la synchronisation",
    "exportFailed": "Échec de l'export",
    "failedToLoadAutomationRules": "Échec du chargement de automation rules",
    "failedToSaveRule": "Échec de l'enregistrement de rule",
    "failedToDeleteRule": "Échec : delete rule",
    "failedToUpdateRule": "Échec de la mise à jour de rule",
    "calendarUnavailableOnCurrentPlan": "Calendar unavailable on current plan",
    "rescheduleFailed": "Échec de reschedule",
    "failedToCreateCampaign": "Échec de la création de campaign",
    "approvalSubmitFailed": "Échec de approval submit",
    "accountNameIsRequired": "Account name is requis",
    "couldNotAddChannel": "Impossible de add channel",
    "connectionFailedSeeSetupGuideForThisNetwork": "Connection failed — see setup guide pour ce network",
    "disconnectFailed": "Échec de disconnect",
    "reconnectFailed": "Échec de reconnect",
    "failedToLoadComments": "Échec du chargement de comments",
    "replyFailed": "Échec de l'envoi de la réponse",
    "resolveFailed": "Échec de resolve",
    "assignFailed": "Échec de l'assignation",
    "couldNotCreateCrmLead": "Impossible de create CRM lead",
    "selectAConnectedAccount": "Sélectionnez un connected account",
    "failedToLoadInbox": "Échec du chargement de inbox",
    "failedToLoadMessages": "Échec du chargement de messages",
    "failedToSendMessage": "Échec : send message",
    "assignmentFailed": "Échec de assignment",
    "escalationFailed": "Échec de escalation",
    "couldNotSaveNote": "Impossible de save note",
    "simulationFailed": "Échec de simulation",
    "failedToLoadPosts": "Échec du chargement de posts",
    "publishFailed": "Échec de publish",
    "connectChannelFirst": "Connect channel first",
    "connectionFailed": "Échec de connection",
    "testsFailed": "Échec de tests",
    "failedToLoadAccounts": "Échec du chargement de accounts",
    "failedToLoadConnectionCenter": "Échec du chargement de connection center",
    "diagnosticsFailed": "Échec de diagnostics",
    "tokenRefreshFailedReconnectChannel": "Token refresh failed — reconnect channel",
    "addKeywordFailed": "Échec de add keyword",
    "failedToLoadFolders": "Échec du chargement de folders",
    "failedToCreateFolder": "Échec de la création de folder",
    "uploadFailed": "Échec du téléversement",
    "deleteFailed": "Échec de la suppression",
    "contentAndAtLeastOnePlatformRequired": "Content et at least one platform requis",
    "createFailed": "Échec de la création",
    "publishFailedUseRetryAfterFixingChannelTokens": "Publish failed — utiliser Retry after fixing channel tokens",
    "retryFailedOpenConnectionCenterToRefreshTokens": "Retry failed — open Connection Center à refresh tokens",
    "contentIsRequired": "Content is requis",
    "selectAtLeastOneConnectedChannel": "Sélectionnez au moins un connected channel",
    "selectAConnectedChannel": "Sélectionnez un connected channel",
    "failedToReply": "Échec : reply",
    "failedToCreateBrand": "Échec de la création de brand",
    "failedToAddKeyword": "Échec de l'ajout de keyword",
    "failedToAddCompetitor": "Échec de l'ajout de competitor",
    "failedToSaveIntegration": "Échec de l'enregistrement de integration",
    "failedToLoadTeam": "Échec du chargement de team",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToLoadCrmLeads": "Échec du chargement de cRM leads",
    "listeningUnavailableOnCurrentPlan": "Listening unavailable on current plan",
    "failedToLoadMediaLibrary": "Échec du chargement de media library",
    "failedToLoadPublishing": "Échec du chargement de publishing",
    "failedToLoadReviews": "Échec du chargement de reviews"
  },
  "pages": {
    "followersAudience": "Followers / audience",
    "reach": "Reach",
    "engagement": "Engagement",
    "messages": "Messages",
    "responseTime": "Response time",
    "clicks": "Clicks",
    "impressions": "Impressions",
    "leadAttribution": "Lead attribution",
    "liveMonitoring": "Live monitoring",
    "topContent": "Top content",
    "analyticsCenter": "Analytics Center",
    "rankedByEngagementFromSyncedSnapshots": "Ranked by engagement de synced snapshots",
    "crossPlatformPerformanceExportsAndScheduled": "Cross-platform performance, exports, et scheduled rapporting",
    "automationCenter": "Automation Center",
    "autoRepliesAssignmentLeadRoutingReview": "Auto-replies, assignment, lead routing, review routing, escalation, et sentiment rules — magasind securely per organization",
    "contentCalendar": "Content Calendar",
    "dragPostsBetweenDaysToReschedule": "Drag posts between days à reschedule — auto-publish runs every 30 seconds",
    "socialCampaigns": "Social Campaigns",
    "crossChannelCampaignsLinkedToMarketing": "Cross-channel campaigns linked à Marketing — no duplicate campaign engine",
    "connectedChannels": "Connected channels",
    "addSocialAccount": "Add social account",
    "addMultiplePagesAccountsOrLocations": "Add multiple Pages, accounts, ou locations per network under one login",
    "commentsCenter": "Comments Center",
    "replyAssignResolveAndConvertFacebook": "Reply, assign, resolve, et convert Facebook, Instagram, LinkedIn, X, et YouTube comments à CRM leads",
    "engagementTrends": "Engagement trends",
    "platformComparison": "Platform comparison",
    "responsePerformance": "Response performance",
    "crossChannelActivityOverTime": "Cross-channel activity over time",
    "engagementAndClicksByChannel": "Engagement et clicks by channel",
    "averageResponseTimeTrendMinutes": "Average response time trend (minutes)",
    "writtenForBusinessOwnersAndMarketing": "Written pour business owners et marketing teams — no technical background requis",
    "socialConnectionCenter": "Social Connection Center",
    "connected": "Connected",
    "avgHealth": "Avg health",
    "tokenIssues": "Token issues",
    "webhookIssues": "Webhook issues",
    "connectValidateAndMonitorEverySocial": "Connect, validate, et monitor every social channel — no developer knowledge requis",
    "crmLeadsFromSocial": "CRM Leads de Social",
    "leadsCreatedFromInboxCommentsReviews": "Leads créé de inbox, comments, reviews, et intake automation",
    "socialCommandCenter": "Centre de commande social",
    "getStarted": "Commencer",
    "getStartedDescription": "Connectez Facebook, Instagram, WhatsApp, LinkedIn et plus — vous pouvez ajouter plusieurs comptes par réseau.",
    "readSetupGuides": "Lire les guides de configuration",
    "addFirstAccount": "Ajouter votre premier compte",
    "publishingCenterLink": "Centre de publication →",
    "connected": "Connecté",
    "notConnected": "Non connecté",
    "areasCount": "{{count}} zones",
    "additionalMetrics": "Additional metrics",
    "comments": "Comments",
    "reviews": "Reviews",
    "leadsGenerated": "Leads generated",
    "publishedPosts": "Published posts",
    "channelHealth": "Channel health",
    "openComments": "Open comments",
    "todaySWork": "Today's work",
    "connectedPlatforms": "Connected platforms",
    "unifiedSocialInboxPublishingAndAnalytics": "Unified social inbox, publishing, et analytics pour votre connected accounts",
    "openADedicatedWorkspaceOnlySupported": "Open a dedicated workspace — only supported features appear",
    "unifiedInbox": "Unified Inbox",
    "allChannels": "All channels",
    "facebookInstagramWhatsappTelegramAndAll": "Facebook, Instagram, WhatsApp, Telegram, et all messaging-capable channels in one queue",
    "socialListening": "Social Listening",
    "brandKeywordAndHashtagMatchesAcross": "Brand, keyword, et hashtag matches across connected channels",
    "mediaLibrary": "Media Library",
    "imagesVideosAndCampaignAssetsOrganized": "Images, videos, et campaign assets — organized in folders avec search et reuse in Publishing",
    "status": "Statut",
    "publishing": "Publishing",
    "notAvailable": "Not disponible",
    "stories": "Stories",
    "reels": "Reels",
    "mentions": "Mentions",
    "publishingCenter": "Publishing Center",
    "composePost": "Compose post",
    "composeScheduleApproveAndPublishAcross": "Compose, schedule, approve, et publish across connected networks",
    "imagesOrVideoForThisPost": "Images ou video pour ce post",
    "createPost": "Create post",
    "multiChannelPostsWithSchedulingMedia": "Multi-channel posts avec scheduling, media, et provider delivery",
    "imagesVideoOrPdf": "Images, video, ou PDF",
    "socialAnalytics": "Social Analytics",
    "followers": "Followers",
    "channelPerformanceMonitoringAndCsvExports": "Channel performance, monitoring, et CSV exports",
    "reviewsCenter": "Reviews Center",
    "totalReviews": "Total reviews",
    "open": "Open",
    "replied": "Replied",
    "avgRating": "Avg rating",
    "googleAndFacebookReviewsReplyAssign": "Google et Facebook reviews — reply, assign, track sentiment, et convert à CRM leads",
    "socialSettings": "Social Paramètres",
    "apiKeysWebhooksBrandsAndShortcuts": "API keys, webhooks, brands, et shortcuts à platform workspaces. Connect channels in Connection Center.",
    "socialSetup": "Social Setup",
    "platformCredentialsMultiBrandListeningAnd": "Platform credentials, multi-brand, listening, et competitor tracking",
    "socialTeams": "Social Teams",
    "assignConversationsAndModerateContentBy": "Assign conversations et moderate content by team member",
    "socialWebhooks": "Social webhooks",
    "configureMetaLinkedinAndOtherNetworks": "Configure Meta, LinkedIn, et other networks à POST inbound events"
  },
  "labels": {
    "ruleName": "Rule name",
    "campaignName": "Campaign name",
    "network": "Network",
    "displayName": "Display name",
    "accountIdOptional": "Account ID (optional)",
    "status": "Statut",
    "assignTo": "Assign to",
    "assignAgent": "Assign agent…",
    "writeAPublicReply": "Write a public reply…",
    "simulateInboundDemo": "Simulate inbound (demo)",
    "message": "Message",
    "typeAReply": "Type a reply…",
    "teamOnlyNoteNotSentTo": "Team-only note (not sent à client)…",
    "sectionTabs": "Section tabs",
    "publishing": "Publishing",
    "inboxDm": "Inbox / DM",
    "comments": "Comments",
    "reviews": "Reviews",
    "analytics": "Analytics",
    "crmIntegration": "CRM integration",
    "selectChannel": "Select channel",
    "addKeyword": "Add keyword",
    "newFolder": "New folder",
    "searchByNameOrTag": "Search by name ou tag…",
    "title": "Title",
    "content": "Content",
    "schedule": "Schedule",
    "mediaAttachment": "Media attachment",
    "optionalMediaFile": "Optional media file",
    "scheduleOptional": "Schedule (optional)",
    "mediaOptional": "Media (optional)",
    "attachMediaToThisPost": "Attach media à ce post",
    "simulateReviewDemo": "Simulate review (demo)",
    "reviewText": "Review text",
    "rating": "Rating",
    "writeAReply": "Write a reply…",
    "platform": "Platform",
    "appIdClientId": "App ID / Client ID",
    "appSecret": "App secret",
    "webhookVerifyToken": "Webhook verify token",
    "profileName": "Profile name",
    "brandName": "Brand name",
    "keywordOrHashtag": "Keyword ou #hashtag"
  },
  "formActions": {
    "saveCredentials": "Enregistrer les identifiants",
    "saveDraftOrSchedule": "Enregistrer le brouillon / planifier"
  },
  "listActions": {
    "newPost": "Nouvelle publication",
    "calendar": "Calendrier",
    "openMediaLibrary": "Ouvrir la médiathèque",
    "trackCompetitor": "Suivre un concurrent",
    "sendTestMessage": "Envoyer un message test",
    "simulateWebhook": "Simuler le webhook",
    "exportPosts": "Exporter les publications",
    "exportInbox": "Exporter la boîte de réception",
    "refreshData": "Actualiser les données",
    "refreshToken": "Actualiser le jeton",
    "reconnectWizard": "Assistant de reconnexion",
    "readSetupGuide": "Lire le guide de configuration",
    "setupWizard": "Assistant de configuration",
    "startGuidedSetup": "Démarrer la configuration guidée",
    "openSetupWizard": "Ouvrir l'assistant de configuration",
    "checkConnectionHealth": "Vérifier l'état de la connexion",
    "openPublishingCenter": "Ouvrir le centre de publication",
    "addAccount": "Ajouter un compte",
    "addAnotherAccount": "Ajouter un autre compte",
    "addAndConnect": "Ajouter et connecter",
    "compose": "Rédiger"
  }
}
